import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';

interface Log {
    actionDate: any;
    actionDescription: string;
    employeeId: string;
    userId: string;
    objectId: string;
    objectDescription: string;
}

interface LogId extends Log {
    id: string;
}

@Injectable()
export class LogService {

    logCollection: AngularFirestoreCollection<Log>;
    logs: any;

    logDocument: AngularFirestoreDocument<LogId>;
    log: Observable<LogId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.LOG_COLLECTION;
    }

    postLog(logObject: any) {
        this.logCollection = this.afs.collection(this.collection);

        return this.logCollection.add(logObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getLogs() {
        this.logCollection = this.afs.collection(this.collection, ref => ref.orderBy('actionDate', 'desc'));

        this.logs = this.logCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Log;

                const actionDate = data.actionDate;
                const actionDescription = data.actionDescription;
                const employeeId = data.employeeId;
                const userId = data.userId;

                return { id$, actionDate, actionDescription, employeeId, userId };
            });
        }).map(object => object);

        return this.logs;
    }

    getLog(id$: string) {
        this.logDocument = this.afs.doc(this.collection + '/' + id$);

        this.log = this.logDocument.valueChanges();

        return this.log.map(object => object);
    }

    putLog(logObject: any, id$: string) {
        this.logCollection = this.afs.collection(this.collection);

        return this.logCollection.doc(id$).update(logObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delLog(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.logDocument = this.afs.doc(this.collection + '/' + id$);

        return this.logDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

    getPayrollLogs(requestedDate: any) {
        this.logCollection = this.afs.collection(this.collection, ref => ref.where('actionDate', '==', requestedDate).
                             where('objectDescription', '==', 'Pago de Nómina'));

        this.logs = this.logCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Log;

                const actionDate = data.actionDate;

                return { id$, actionDate };
            });
        }).map(object => object);

        return this.logs;
    }

}
